import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import logo from '../assets/Group.png'
import logoCFN from '../assets/CFN-xs.png'
import arrowback from '../assets/backarrow.svg'
import { setCurrentTab, setErrorEncrypt, setFirstFormCompleted, setGlobalTab, setHandleChangeBeneficiary, setTypeBeneficiary } from '../redux/reducer/stepReducer/stepReducer'
import ButtonDrawer from '../components/ButtonDrawer'
import { createErrorEmail, searchCities } from '../redux/reducer/stepReducer/thunks'
import { CODEMP_MUSIMUNDO } from '../utilities'
import { AppBar, Box, Toolbar, styled } from '@mui/material'

const PRODUCTS_TECNOLOGY = ['159', '161'];
const PROTECTED_HOME = '8';
const PROTECTED_BAG = '19';
const EMPLEABILITY = '62';
const PERSONAL_ACCIDENTS = '12'

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  maxHeight: "60px"
});


const Navbar = (props) => {
  const { firstStep, typeBeneficiary, paramsMus, titularData } = useSelector((state) => state.firstStep);
  const { codemp } = useSelector(state => state.adminReducer.login);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBack = async () => {
    const allowProducts = ["8", "12", "19", "62", "159", "161"];
    const url = window.location.href.split('/')[5];
    if (url === 'elegirPlan' || allowProducts.includes(url)) return navigate('/');
    if (url === 'datosTitular') {
      return navigate('/elegirPlan');
    }
    if (url === 'datosHogar' || url === 'datosTecnologia') {
      if (firstStep.codsec === '8') {
        try {
          await dispatch(searchCities(titularData.province, firstStep.codcia));
        } catch (error) {
          let message = `Error searchCities | ${error}`;
          dispatch(createErrorEmail(message));
          dispatch(setErrorEncrypt(true))
          navigate('/error');
        }
      }
      dispatch(setFirstFormCompleted(true));
      return navigate('/datosTitular');
    }
    if (url === 'datosBeneficiario') {
      dispatch(setTypeBeneficiary(''));
      dispatch(setHandleChangeBeneficiary([]));
      dispatch(setFirstFormCompleted(true));
      localStorage.removeItem("typeBeneficiary");
      localStorage.removeItem("checkedItems");
      localStorage.removeItem("expanded");
      localStorage.removeItem("completedCheck");
      return navigate('/datosTitular');
    }
    if (url === 'detalleBeneficiario') {
      // dispatch(setEditBeneficiaries(true));
      return navigate('/datosBeneficiario')
    }
    if (url === 'pago') {
      localStorage.removeItem("pago");
      if (firstStep.codsec === PROTECTED_BAG || firstStep.codsec === EMPLEABILITY) {
        dispatch(setFirstFormCompleted(true));
        return navigate('/datosTitular');
      }
      if (firstStep.codsec === PROTECTED_HOME) return navigate('/datosHogar');
      if (firstStep.codsec === PERSONAL_ACCIDENTS) {
        dispatch(setCurrentTab(2));
        dispatch(setGlobalTab(2.6));
        return typeBeneficiary == 'legal' ? navigate('/datosBeneficiario') : navigate('/detalleBeneficiario')
      }
      if (PRODUCTS_TECNOLOGY.includes(firstStep.codsec)) {
        dispatch(setCurrentTab(2));
        dispatch(setGlobalTab(2.6));
        return navigate('/datosTecnologia');
      }
    }
    if (url === 'questions') {
      window.history.back();
    }
  };

  return (
    <AppBar position='sticky' sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
      <StyledToolbar>
        {
          <Box>
            <img src={arrowback} alt="" onClick={handleBack} style={{ cursor: 'pointer' }} />
          </Box>
        }
        <Box sx={{ marginLeft: { xs: CODEMP_MUSIMUNDO.includes(codemp) && '7vw', md: '0vw' } }}>
          {
            CODEMP_MUSIMUNDO.includes(codemp) ?
              <div><img src={logo} alt="logomus" style={{ cursor: 'pointer' }} /></div> :
              <div style={{ display: 'flex', justifyContent: 'center' }}><img style={{ width: '50%', cursor: 'pointer' }} src={logoCFN} alt="logocfn" /></div>
          }
        </Box>
        <Box>
          <div><ButtonDrawer codpmpol={(paramsMus?.nro || props.codpmpol || '')} /> </div>
        </Box>
      </StyledToolbar>
    </AppBar >
  )
}

export default Navbar;